import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';

import { StepItem } from '../step/step-item';
import { Step } from '../../app/entities/step';
import { useDroppable } from '@dnd-kit/core';

type StepListProps = {
  id: string;
  steps: Step[];
};

export const StepList: React.FC<StepListProps> = observer(({ steps = [], id }) => {
  const { setNodeRef } = useDroppable({
    id,
    data: {
      type: 'stage',
      stageId: id,
    },
  });

  const stepsIds = steps.filter((step) => step.type !== 'shootingDay').map((step) => step._id);

  return (
    <StepListItem>
      <SortableContext id={id} items={stepsIds} strategy={verticalListSortingStrategy}>
        <div ref={setNodeRef}>
          {steps.map((step) => (
            <StepItem key={step._id} step={step} />
          ))}
        </div>
      </SortableContext>
    </StepListItem>
  );
});

const StepListItem = styled.div`
  position: relative;
  z-index: 99;

  a {
    text-decoration: none;
  }
`;
